<template>
	<div class="head_watch home-banner container__large margin-auto" v-if="bannerData">
		<div
			class="video-hold"
			v-if="currentPage && currentPage.acf && currentPage.acf.page_banner.video"
			v-html="currentPage.acf.page_banner.video"
		></div>
		<WpImage :key="bannerImage.id" :image="bannerImage" size="extra_large" background cover />

		<div class="banner-black_box padding-lg">
			<h1 class="banner-title" v-if="bannerData.title" v-html="bannerData.title"></h1>
			<div class="banner-desc" v-if="bannerData.description" v-html="bannerData.description"></div>
			<div class="banner-links margin-top-sm" v-if="bannerData.buttons && bannerData.buttons.length">
				<ColorLink
					v-for="({ link, color }, k) in bannerData.buttons"
					:outlined="!isDarkMode ? color !== 'white' : color === 'white'"
					:key="k"
					:link="link"
					:color="color"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import WpImage from '@/components/elements/WpImage'
import ColorLink from '@/components/elements/ColorLink'

import { mapGetters } from 'vuex'

export default {
	name: 'home-banner',
	computed: {
		...mapGetters(['currentPage', 'isDarkMode']),
		bannerImage() {
			return this.bannerData.image || false
		},
		bannerData() {
			return this.currentPage && this.currentPage.acf && this.currentPage.acf.page_banner
				? this.currentPage.acf.page_banner
				: false
		},
	},
	components: {
		WpImage,
		ColorLink,
	},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';
@import '@/assets/extends.scss';

.home-banner {
	color: var(--light);
	position: relative;
	margin-bottom: 175px;
	@include mquery($tablet) {
		margin-bottom: 100px;
	}
	@include mquery($phone) {
		margin-bottom: 30px;
		margin-right: -35px;
	}
	.banner-black_box {
		position: absolute;
		right: 116px;
		bottom: -100px;
		background: var(--dark);
		z-index: 5;
		@include mquery($tablet) {
			right: 87px;
			left: 87px;
		}
		@include mquery($phone) {
			right: 0px;
			left: 0px;
			position: relative;
			bottom: 0;
		}
	}
	.video-hold {
		position: absolute;
		z-index: 2;
		left: 0;
		right: 0;
		padding-bottom: 56.25%;
		height: 0;
		top: 0;
		iframe {
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			width: 100%;
			height: 100%;
		}
	}
	.banner-title {
		@include fluid-type($smallResText, $wideResText, 26px, 40px);
		font-weight: 300;
		margin-top: 0;
		margin-bottom: 25px;
		line-height: 1.3;
	}
	.banner-desc {
		@include fluid-type($smallResText, $wideResText, 18px, 25px);
	}
	.fill-button {
		margin-right: 20px;

		&:last-child {
			margin-right: 0;
		}
		@include mquery($phone) {
			margin-right: 0;
			width: 100%;
			margin-bottom: 20px;
			&:last-child {
				margin-bottom: 0;
			}
		}
	}
}
</style>
